import { LikutWarehouseService } from '../services/likut-warehouse.service';
import { LIKUT_ADMIN_TYPES } from '../services/likut.service';
import { AllClients } from './SQL-morning-responses';

export type LikutStatus = '0' | '1' | '2' | '3' | '4' | '5' | '6';
export type LikutPath = 'likut';
//likut-scan
export type LikutFinishBodyNewRoutes = {
	TeudaNum: string;
	TeudaType: number;
} & (LikutFinishBodyNewRoutesMainTable | LikutFinishBodyNewRoutesSubTable | LikutFinishBodyNewRoutesScansTable);

export type LikutFinishNewRoutesPossibleEndpointsMode = 'melaketScans' | 'melaketAdded' | 'melakerOrChecker';

export type LikutFinishBodyNewRoutesSubTable = {
	table: 'sub';
	ProductId: string;
	LStatus: string;
	LikutQty: number;
	LikutPackQty: number;
	LikutPrice?: number;
	TeudaLineNum: string;
	TeudaNum: string;
	ID?: string;
	DocID?: string;
};

// export type LikutFinishBodyNewRoutes = {
// 	TeudaNum: string;
// 	TeudaType: number;
// } & (LikutFinishBodyNewRoutesMainTable | LikutFinishBodyNewRoutesSubTable);

// type LikutFinishBodyNewRoutesSubTable = {
// 	table: 'sub';
// 	ProductId: string;
// 	LStatus: string;
// 	LikutQty: number;
// 	LikutPackQty: number;
// 	LikutPrice?: number;
// 	TeudaLineNum: number;
// };

type LikutFinishBodyNewRoutesMainTable = {
	table: 'main';
	LikutStatus: string;
	MelaketName: string;
	CheckerName: string;
	LikutSignature: string;
	CheckerSignature: string;
	LikutCheckDate: string;
	LikutDate: string;
	MelaketRemark: string;
	CheckerRemark: string;
	QuantitiesMatch: QuantitiesMatch;
};

export type LikutFinishBodyNewRoutesScansTable = {
	table: 'scans';
	DocId: string;
	RowId: string;
	ProductId: string;
	ScanNum: number;
	ScanTime: Date;
	QTY: number;
	Tokef: string | null;
	PackID: number | null;
	PackQTY: number | null;
	PackageSug: number | null;
	Eitur: string | null;
	Source: ScanHistoryOriginSource;
	OriginalBarcode: string;
	TeudaNum: string;
	TeudaType: number;
};

export type LikutUsers = {
	Admin: typeof LIKUT_ADMIN_TYPES[number];
	melaketid: string;
	melaketname: string;
	pass: string;
};

export type LikutMainSQL = {
	ID: string;
	TeudaNum: string;
	TeudaType: number;
	Client_Id: string;
	TeudaCreateDate: string;
	TeudaSupplyDate: string;
	TeudaAgent: string;
	Client_Name: string;
	User_Name: string;
	TuedaErpDocNum: string;
	Address: string;
	City: string;
	TeudaCompany: number;
	LikutStatus: LikutStatus | null;
	MelaketName: string | null;
	CheckerName: string | null;
	LikutExtra1: string | null;
	LikutExtra2: string | null;
	LikutExtra3?: string | null;
	LikutDate: string | null;
	LikutSignature: string | null;
	CheckerSignature: string | null;
	LikutCheckDate: string | null;
	OpenedBy: string | null;
	CheckerRemark: string | null;
	MelaketRemark: string | null;
	AssignedTo: string | null;
	TotalLines: number;
	QuantitiesMatch: QuantitiesMatch | null;
	AreaId?: string | null;
	AreaName?: string;
	LineNum: number;
	Color?: string | null;
	Filter?: string | null;
	DocNum?: number | null;
	DocType?: number | null;
};

export type LikutTaskDisplayWithAssignment = LikutDisplayMain & {
	AssignedTo: string | null;
	OpenedBy: string;
	LikutDate: string;
	LineNum: number;
	LikutExtra1?: string;
	LikutExtra2?: string;
	LikutExtra3?: string;
	colorForBackground?: string;
};

export type LikutSubSQL = {
	TeudaNum: string;
	TeudaType: number;
	ProductId: string;
	//likut-scan
	// TeudaLineNum: string;
	TeudaLineNum: number;
	ProductName: string;
	TeudaQuantity: number;
	TeudaPackQuantity: number;
	TeudaBonusQuantity: number;
	TeudaBonusPackQuantity: number;
	TeudaPrice: number | null;
	TeudaItemRemark: string;
	Amount: number;
	Arizot: number;
	TeudaUnitPerPack: number;
	PicName: string;
	Stock: number;
	ItemPack: number;
	LStatus: LStatuses;
	LikutQty: number | null;
	LikutExtra1: string | null;
	LikutExtra2: string | null;
	LikutPackQty: number | null;
	LikutPrice?: number | null;
	Eitur?: string;
	Barcode?: string;
	ID: string;
	DocID: string;
};

export type LikutConcentratedLine = {
	ProductId: LikutSubSQL['ProductId'];
	ProductName: LikutSubSQL['ProductName'];
	Barcode: LikutSubSQL['Barcode'];
	TeudaQuantity: LikutSubSQL['TeudaQuantity'];
	Filter: string | number;
	filter2: string | number;
};

export const LStatusesDict = {
	regular: '0',
	manuallyAdded: '5',
} as const;
export type LStatuses = typeof LStatusesDict[keyof typeof LStatusesDict];

export const QuantitiesMatchDict = {
	notMatch: 0,
	match: 1,
	addedProducts: 2,
} as const;
export type QuantitiesMatch = typeof QuantitiesMatchDict[keyof typeof QuantitiesMatchDict];

type LikutDisplayBase = { clientName: string; clientid: string; totalRow: number; totalTeudot: number; status: LikutStatus };
type LikutFromLikutMain = { teudot: Record<string, LikutMainSQL>; address: string; city: string; quantitiesMatch: 0 | 1 | 2; filter?: string[]; addedProducts?: boolean };

export type LikutDisplayMain = LikutDisplayBase & LikutFromLikutMain;

export const LIKUT_ROUTES = [
	'clients',
	'tasks',
	'finish',
	'manage',
	'manage-part',
	'manage-assignment',
	'manage-not-fulfilled',
	'manage-no-status',
	'assign-users-tasks',
	'clients/mekabel',
	'clients/mekabel-returns',
	'concentrated-quantities',
	'barcodes/manage/products',
	'barcodes/manage/definitions',
] as const;

export type LikutNavigation = {
	mode: LikutPath;
	route: typeof LIKUT_ROUTES[number];
};

export type LikutKabalaStatus = '0' | '1' | '2' | '5' | '6';

export type LikutKabalaMainSQL = {
	TeudaNum: string | null;
	TeudaType: number | null;
	Client_Id: string | null;
	TeudaDate: Date | null;
	TeudaKabalaDate: Date | null;
	TeudaAgent: string | null;
	Client_Name: string | null;
	TeudaErpNum: string | null;
	TeudaCompany: number | null;
	MekabelId: string | null;
	MekabelName: string | null;
	Extra1: string | null;
	Extra2: string | null;
	TotalLines: number | null;
	Remark: string | null;
	TeudaStatus: LikutKabalaStatus | null;
	DATAString: string | null;
	PrintStatus: number | null;
	TeudaErpErr: string | null;
	Extra3: string | null;
	Extra4: string | null;
	Extra5: string | null;
	Warehouse: string | null;
	Warehouse2: string | null;
	Currency: string | null;
	Rate: number | null;
	StringNum: string | null;
	SignatureString: string | null;
	ImageFileName: string | null;
	TeudaReference: string | null;
};

export type LikutKabalaSubSQL = {
	TeudaNum: string | null;
	TeudaType: number | null;
	Extra1: string | null;
	Extra2: string | null;
	ProductId: string | null;
	Barcode: string | null;
	TeudaLineNum: number | null;
	ProductName: string | null;
	TeudaQty: number | null;
	TeudaQtyKabala: number | null;
	TeudaPackQty: number | null;
	TeudaPackQtyKabala: number | null;
	Price: number | null;
	Discount: number | null;
	ItemPicName: string | null;
	ItemPack: number | null;
	Eitur: string | null;
	Extra3: string | null;
	Extra4: string | null;
	Extra5: string | null;
	Warehouse: string | null;
	Warehouse2: string | null;
	Currency: string | null;
	Rate: number | null;
	ItemStatus: string | null;
	Stock: number | null;
	PriceOut: number | null;
	DiscountOut: number | null;
	ItemRemark: string | null;
};

export const scanHistoryOriginSource = {
	mainScreen_BarcodeStream: 0,
	popupScreen_BarcodeStream: 1,
	popupScreen_Manual: 2,
	beforeSend_translatedQuantity: 3,
} as const;

export type ScanHistoryOriginSource = typeof scanHistoryOriginSource[keyof typeof scanHistoryOriginSource];

export type LikutScanParameterKeys = 'shouldIgnoreScanListeningWhilePopupOpen';

export type ScanHistoryIncomingItem = {
	barcode: string;
	weight: number;
	time?: Date;
	quantity?: number;
	teudanum: string;
};
export type ScanHistoryItem = { barcode: string; weight: number; time: Date; quantity: number; id: string; teudanum: string };

export type ScanHistorySummedDictionary = Record<string, { weight: number; quantity: number }>;

export type LikutMekabelDisplay = {
	clientid: string;
	clientName: string;
	status: LikutKabalaStatus;
	rows: LikutKabalaSubSQL[];
	totalRow: number;
	supplier: {
		name: string;
		id: string;
	};
	warehouse: {
		name: string;
		id: string;
	};
	doctype: { num: number; name: string };
	refrenceNumber: string;
};

export type LikutMekabelTaskExtra = { signature: string; image: string; name: string; remark: string };

export type LikutMekabelFinishBody = {
	TeudaNum: string;
	TeudaType: number;
} & (LikutMekabelFinishBodySubTable | LikutMekabelFinishBodyMainTable | LikutFinishBodyNewRoutesScansTable);

export type LikutMekabelFinishBodyForUnexistingTask = LikutMekabelFinishBodyMainTableForNewTask | LikutMekabelFinishBodySubTableForNewTask | LikutFinishBodyNewRoutesScansTable;

export interface LikutMekabelFinishBodySubTable {
	table: 'sub';
	ItemStatus: string;
	TeudaQtyKabala: number;
	TeudaPackQtyKabala: number;
	PriceOut: number;
	DiscountOut: number;
	ItemRemark: string;
	Eitur: string;
	ProductId: string;
	Warehouse: string;
	TeudaLineNum: number;
}
export type LikutMekabelFinishBodySubTableForNewTask = LikutKabalaSubSQL & {
	table: 'sub';
};
type LikutMekabelFinishBodyMainTableForNewTask = Omit<LikutKabalaMainSQL, 'TeudaKabalaDate' | 'TeudaDate'> & {
	table: 'main';
	TeudaKabalaDate: string;
	TeudaDate: string;
};

type LikutMekabelFinishBodyMainTable = {
	table: 'main';
	MekabelId: string;
	TeudaKabalaDate: string;
	MekabelName: string;
	Remark: string;
	TeudaStatus: string;
	DATAString: string;
	SignatureString: string;
	ImageFileName: string;
};

export type MekabelWarehouse = {
	WarehouseId: string;
	WarehouseName: string;
};

export type NewLikutMekabelWarehouseFormResult = {
	warehouse: MekabelWarehouse;
	supplier: AllClients;
};

export type LikutKanbanUsers = {
	AgentID: string;
	Admin: string;
	UserName: string;
};

type LikutAssignmentUpdateBodyBase = { TeudaNum: string };

export type LikutAssignmentUpdateLineNum = LikutAssignmentUpdateBodyBase & { LineNum: number };
// export type LikutAssignmentUpdateDate = LikutAssignmentUpdateBodyBase & { LoadDate: string };
export type LikutAssignmentUpdateAgent = { TeudaNum: string[]; AssignTo: string };

export type LikutWarehouse = {
	WarehouseID: string;
	WarehouseName: string;
	Type: string | null;
	Details: string | null;
};

export type LikutPrinter = {
	PrinterID: number;
	PrinterName: string;
	PrinterMAC: string | null;
	PrinterDriver: string | null;
};

export type LikutPalletProducts = {
	ProductName: string;
	ForigenName: string;
	ProductId: string;
	ItemPack: number;
	Barcode: string;
	PalletNum: number;
	PackPerPallet: number;
	Color: string;
	Extra1: string;
	Extra2: string;
	Extra3: string;
	Active: string;
	ItemPicName: string;
	Tokef: string;
	Kashrut: string;
};

export type LikutPaletteMoves = {
	ID: number;
	MoveID: number;
	PaletteID: number;
	Count: number;
	MoveDate: string;
	WarehouseID: string;
	Extra1: string | null;
	Extra2: string | null;
	Extra3: string | null;
	UserID: string | null;
	Color: string | null;
};

export type LikutPaletteMovesAllInventory = LikutPaletteMoves & {
	Quantity: number;
	instock: number;
	PackQTY: number;
	CreateDate: string;
	OrgWarehouseID: string;
	ProductName: string;
	ProductID: string;
	TokefDate: string;
	Color: string | null;
};

export type LikutPaletteMovesAllInventoryDisplay = LikutPaletteMovesAllInventory & {
	isOtherWarehouse: boolean;
	isOtherWarehouseAndNewItem: boolean;
	isWarehouse99: boolean;
};

export type LikutPalette = {
	ID: number;
	PalleteID: number;
	ProductId: string;
	Barcode: string;
	PackQTY: number;
	ItemPack: number;
	CreateDate: Date;
	TokefDate: Date;
	Extra1: string | null;
	Extra2: string | null;
	Extra3: string | null;
	Extra4: string | null;
	Status: string | null;
	Color: string | null;
	Active: number | null;
	PrintStatus: number;
	PrinterID: number;
	OrigUserID: string | null;
	UserID: string | null;
};

export type CreatePalletResponse = { err: true; msg: string } | { err: false; msg: string; palletIDs: number[] };

export type CreatePalletBody = Array<
	| {
			table: 'LikutPalette'; // should include all the columns
			ProductId: string;
			Barcode: string;
			PackQTY: number;
			ItemPack: number;
			TokefDate: Date;
			Extra1: string | null;
			Extra2: string | null;
			Extra3: string | null;
			Extra4: string | null;
			Status: string | null;
			Color: string | null;
			Active: number | null;
			PrintStatus: number;
			PrinterID: number;
			_id: string;
	  }
	| {
			table: 'LikutPaletteMoves';
			WarehouseID: string;
			Extra1: string | null;
			Extra2: string | null;
			Extra3: string | null;
			UserID: string | null;
			Color: string | null;
			ProductId: string;
			_id: string;
	  }
>;

export type TransferPalletBody = {
	PaletteID: number;
	Count: 1 | -1;
	WarehouseID: string;
	UserID: string;
	Extra1?: string;
	Extra2?: string;
	Extra3?: string;
};

export type LikutPalletValidation = {
	PaletteID: number;
	WarehouseID: string;
	instock: number;
	CreateDate: Date;
	TokefDate: Date;
	ProductName: string;
	ProductId: string;
	PackQTY: number;
	color: string;
};

export type LikutPalletValidationWithTimestamp = LikutPalletValidation & { timestamp: number };

export type LikutDialogDataInput = {
	titleToDisplay: string;
	mode: LikutDialogPageModes;
	buttonText: string;
	startFromWarehouse?: string;
	startWithPallet?: LikutPalletValidation;
};

export type LikutDialogPageModes =
	| 'reprint'
	| 'create-chooseProduct'
	| 'create-w-chooseProduct'
	| 'create-createPallet'
	| 'create-w-createPallet'
	| 'transfer-chooseWarehouse'
	| 'transfer-transferPallet'
	| 'delete-sendPalletOut'
	| 'inventory-scan'
	| 'transferFromAllInventoryReport'
	| 'pallet-info-choosePallet'
	| 'pallet-info-palletInfo';

export type LikutWarehouseInventoryResponse = {
	PaletteID: number;
	WarehouseID: string;
	instock: number;
	CreateDate: string;
	TokefDate: string;
	ProductName: string | null;
	ProductId: string | null;
	PackQTY: number;
	Color: string | null;
	Remark?: string | null;
};

export type LikutWarehouseInventoryDisplay = {
	ProductName: LikutWarehouseInventoryResponse['ProductName'];
	ProductId: LikutWarehouseInventoryResponse['ProductId'];
	WarehouseID: LikutWarehouseInventoryResponse['WarehouseID'];
	TokefDate: Date;
	instock: LikutWarehouseInventoryResponse['instock'];
	PackQTY: LikutWarehouseInventoryResponse['PackQTY'];
	Color: LikutWarehouseInventoryResponse['Color'];
};

export type LikutWarehouseInventoryDisplayWithScans = LikutWarehouseInventoryDisplay & {
	totalScanned: number;
	isWarehouse99: boolean;
	isOtherWarehouse: boolean;
	isOtherWarehouseAndNewItem: boolean;
	isScansValid: boolean;
};

export type LikutWarehouseInventoryDisplayWithScansInstockString = Omit<LikutWarehouseInventoryDisplayWithScans, 'instock'> & {
	instock: string;
};

export type LikutWarehouseInventoryPopupWithScanInfo = LikutWarehouseInventoryResponse & {
	isScanned?: boolean;
	color?: string;
	isInInventory: boolean;
};

export type LikutWarehouseButtons = {
	ID: number;
	button_id: keyof typeof LikutWarehouseService.prototype.actionsAvailable;
	text: string;
	URL: string;
	typeof: '0' | '1' | '2';
	color: string;
};

export type LikutWarehouseAvailableButtons = Record<string, boolean>;

export type LikutWarehouseScanInventoryFinishBody = {
	UserID: string;
	WarehouseID: string;
	DocID: string;
	lines: { PaletteID: number; ProductID: string; PackQTY: number }[];
};

export type LikutWarehouseMoveResponse = {
	ID: number;
	DocID: string;
	DocType: number;
	DocCreateDate: string;
	UserID: string;
	WarehouseID: string;
	Status: string;
	PrintStatus: number;
};

export type LikutWarehousePalletMovementsByDateResponse = {
	ID: number;
	MoveID: number;
	PaletteID: number;
	Count: number;
	MoveDate: string;
	WarehouseID: string;
	Extra1: any;
	Extra2: any;
	Extra3: any;
	UserID: string;
	Color: string;
	ProductId: string;
	ProductName: string;
};

export type LikutBarcodeDefinition = {
	Id: number;
	BarcodeName: string;
	BarcodeLen: number;
	MakatLoc: number;
	MakatLen: number;
	QtyLoc: number | null;
	QtyLen: number | null;
	QtyDot: number | null;
	TokefDay: number | null;
	TokefMonth: number | null;
	TokefYear: number | null;
	YearSegment: number | null;
	PackIdLoc: number | null;
	PackIdLen: number | null;
	PackQTY: number | null;
	PackageSug: number | null;
};

type RequiredLikutBarcodeDefinition = Required<Pick<LikutBarcodeDefinition, 'BarcodeName' | 'BarcodeLen' | 'MakatLoc' | 'MakatLen'>>;
type OptionalLikutBarcodeDefinition = Partial<Omit<LikutBarcodeDefinition, 'BarcodeName' | 'BarcodeLen' | 'MakatLoc' | 'MakatLen' | 'Id'>>;

export type LikutBarcodeDefinitionPayload = RequiredLikutBarcodeDefinition & OptionalLikutBarcodeDefinition;

export type LikutProductBarcode = {
	RowID: number;
	ProductId: string;
	IdFromBarcode: string;
	BarcodeDefId: number;
	BarcodeLen: number;
	QTYDefault: number | null;
	QTYPackDefault: number | null;
};
export type LikutProductBarcodePayload = {
	ProductId: string;
	IdFromBarcode: string;
	BarcodeDefId: number;
	BarcodeLen?: number;
	QTYDefault?: number;
	QTYPackDefault?: number;
};

export type LikutProductBarcodeWithDefinition = { productWithBarcode: LikutProductBarcode } & { definition: LikutBarcodeDefinition };

export type LikutBarcodeScanItem = {
	uuid: string;
	timestamp: number;
	rowId: string;
	scanNum: number;
	productId: string;
	teudanum: string;
	qty: number;
	tokef: string | null;
	packId: number | null;
	packQty: number | null;
	packageSug: number | null;
	eitur: string | null;
	source: ScanHistoryOriginSource;
	originalBarcode: string;
};
